import { CupoService } from '../../../models/cupo/service/cuposService'
import { FORM_CUPO } from '../../../config/forms'
import { getFormValues, reset } from 'redux-form'
import { toast } from 'react-toastify'
import moment from 'moment'
import ParametroText from '../../../models/parametro/parametro_text'
import ParametroTimestamp from '../../../models/parametro/parametro_timestamp'

export function parseCupos (data) {
  const parsedData = []
  data.data.forEach(entry => {
    parsedData.push({ ...entry, cupo: entry })
  })
  return parsedData
}

export async function getCupos () {
  return parseCupos(await CupoService.getCupos())
}

export function updateParametroText (nombre, value) {
  return ParametroText.updateByNombre(nombre, value)
}

export function updateParametroTimestamp (nombre, value) {
  return ParametroTimestamp.updateByNombre(nombre, value)
}

export function insertarParametroText (nombre, descripcion, value) {
  const valor = value.toString()
  return ParametroText.insertParameter(nombre, descripcion, valor)
}

export function insertParametroTimestamp (nombre, descripcion, value) {
  return ParametroTimestamp.insertParameter(nombre, descripcion, value)
}

export function getAdelantosProgramados () {
  return dispatch => {
    dispatch({ type: 'REQUEST_PARAMETROS_ADELANTO_CUPOS' })
    Promise.all([
      ParametroText.getByNombre('CERASICU'),
      ParametroTimestamp.getByNombre('LCCDESDE'),
      ParametroTimestamp.getByNombre('LCCHASTA')
    ])
      .then(([cerealesAdelanto, limiteCupoDesde, limiteCupoHasta]) => {
        dispatch({ type: 'RECEIVE_PARAMETROS_ADELANTO_CUPOS', cerealesAdelanto, limiteCupoDesde, limiteCupoHasta })
      })
      .catch(error => {
        console.log(error)
      })
  }
}

export function deleteAdelantoProgramado () {
  return (dispatch) => {
    Promise.all([
      ParametroText.deleteParameter('CERASICU'),
      ParametroTimestamp.deleteParameter('LCCDESDE'),
      ParametroTimestamp.deleteParameter('LCCHASTA')
    ])
      .then(() => {
        dispatch({ type: 'DELETE_ADELANTO_PROGRAMADO' })
      })
      .catch(error => {
        console.log(error)
      })
  }
}

export function updateAdelantoProgramado (values) {
  return (dispatch) => {
    Promise.all([
      updateParametroText('CERASICU', values.cereales),
      updateParametroTimestamp('LCCDESDE', values.fechaD),
      updateParametroTimestamp('LCCHASTA', values.fechaH)
    ])
      .then(() => {
        dispatch({ type: 'ADELANTO_DE_CUPOS' })
        toast.success('Adelanto de cupos programado correctamente')
        dispatch(getAdelantosProgramados())
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al programar adelanto de cupos')
      })
    dispatch(reset(FORM_CUPO))
  }
}

export function insertarAdelantoProgramado (values) {
  return (dispatch) => {
    Promise.all([
      insertarParametroText('CERASICU', 'Cereales programados para adelantar cupos', values.cereales),
      insertParametroTimestamp('LCCDESDE', 'Fecha inicio del adelanto de cupos', values.fechaD),
      insertParametroTimestamp('LCCHASTA', 'Fecha limite del adelanto de cupos', values.fechaH)
    ])
      .then(() => {
        dispatch({ type: 'ADELANTO_DE_CUPOS' })
        toast.success('Adelanto de cupos programado actualizado correctamente')
        dispatch(getAdelantosProgramados())
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al programar adelanto de cupos')
      })
    dispatch(reset(FORM_CUPO))
  }
}

export function adelantarCupos () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_CUPO)(state)
    const cerealesAdelanto = state.cupos.cerealesAdelanto

    if (!formValues) {
      toast.error('Todos los campos deben estar completos')
      dispatch(reset(FORM_CUPO))
      return
    }

    var valuesCereales = formValues.cereales

    var cereales = '{' + (valuesCereales.map(c => c.trim()).join(',')) + '}'
    console.log(cereales)

    formValues.cereales = cereales
    formValues.cerealesAdelanto = cereales
    const fechaDesde = formValues.fechaD
    const fechaHasta = formValues.fechaH
    const horaAdelanto = formValues.horaAdelanto
    const fechaD = moment(fechaDesde + ' ' + horaAdelanto, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY HH:mm')
    const fechaH = moment(fechaHasta + ' 00:00', 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY HH:mm')

    formValues.fechaD = fechaD
    formValues.fechaH = fechaH

    if (cerealesAdelanto && cerealesAdelanto.length > 0) {
      dispatch(updateAdelantoProgramado(formValues))
    } else {
      dispatch(insertarAdelantoProgramado(formValues))
    }
  }
}
